import {
  NEQ_INPUT_CHANGE,
  NEQ_SUBMIT_ANSWER
} from '../../Redux.constants';
import {
  updateNumericEntry,
  submitNEQAnswer
} from './helper';

export function NEQReducer(state = {}, action) {
  switch (action.type) {
    case NEQ_INPUT_CHANGE:
      return updateNumericEntry(state, action.payload);
    case NEQ_SUBMIT_ANSWER:
      return submitNEQAnswer(state, action.payload);
    default:
      return state;
  }
}
